

export class HouseHoldSummary {
    constructor(
        public FIRST_NAME?: string,
        public LAST_NAME?: string,
        public DOB_DT?: string,
        public RELATION_TO_WR_INDIVIDUAL?: string,
        public WORK_PARTICIPATION_CD?: string,
        public OTHER_CHARACTERISTICS?: string,
        public GENDER_CD?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-et-enrollment-household-summary.model.ts